import type { AppError } from '../core/error/appError';

/**
 * Estado de pantalla con los cuatro casos posibles como variantes explícitas.
 *
 * Es un tipo discriminado a propósito: el compilador impide olvidarse del estado vacío o del de
 * error, que es exactamente lo que produce las pantallas en blanco y los spinners infinitos.
 */
export type UiState<T> =
  | { readonly status: 'LOADING' }
  | { readonly status: 'SUCCESS'; readonly data: T }
  | { readonly status: 'EMPTY' }
  | { readonly status: 'ERROR'; readonly error: AppError };

export const UiStates = {
  loading: <T>(): UiState<T> => ({ status: 'LOADING' }),
  success: <T>(data: T): UiState<T> => ({ status: 'SUCCESS', data }),
  empty: <T>(): UiState<T> => ({ status: 'EMPTY' }),
  error: <T>(error: AppError): UiState<T> => ({ status: 'ERROR', error }),

  /** Lista vacía ⇒ estado vacío, no un `SUCCESS` con cero elementos que la UI deba inspeccionar. */
  fromList: <T>(items: readonly T[]): UiState<readonly T[]> =>
    items.length === 0 ? { status: 'EMPTY' } : { status: 'SUCCESS', data: items },
};
